import React from 'react'

import { Grid, Segment, Header, Button, Icon, Divider } from 'semantic-ui-react'

import ExternalLink from '../../components/common/ExternalLink'
import Section from '../../components/common/Section'
import SubSection from '../../components/common/SubSection'
import Title from '../../components/common/Title'

import HelpCentreVideoThumbnail from './HelpCentreVideoThumbnail'

import { HELPDOCS_URL } from '../../config/environments'

const helpVideos = [
  {
    header: 'Vloggi Studio Quick Overview',
    videoLink: 'https://www.loom.com/embed/cabd637e4806472eb5f59da655f6b8fe',
  },
  {
    header: 'Video Templates - which one is for me',
    videoLink: 'https://www.youtube.com/watch?v=k34i3_yssFg',
    provider: 'youtube'
  },
  {
    header: 'Managing Your Video Library',
    videoLink: 'https://www.loom.com/embed/fe4ce416bcde4d5eacfd4bcf505f2a80',
  },
]

const helpArticles = [
  {
    section: 'COLLECTING VIDEO SUBMISSIONS',
    articles: [
      {
        name: 'How to write a successful landing page to maximize video submissions',
        link: 'https://vloggi.com/docs/how-to-write-a-successful-landing-page-to-maximize-video-submissions/',
      },
      {
        name: 'Adding a welcome video to your video submission landing page',
        link: 'https://vloggi.com/docs/why-you-should-add-a-welcome-video-to-your-video-submission-landing-page/',
      },
      {
        name: '8 Tips to higher response rates for your video submission project',
        link: 'https://vloggi.com/docs/8-tips-to-higher-response-rates-for-your-video-submission-project/',
      },
      {
        name: 'Where do I share my video submission project upload link?',
        link: 'https://vloggi.com/docs/where-do-i-share-my-video-submission-project-upload-link/',
      },
      {
        name: 'How to enable webcam responses to video questionnaires on Vloggi',
        link: 'https://vloggi.com/docs/how-to-enable-webcam-responses-to-video-questionnaires-on-vloggi/',
      },
      {
        name: 'Building a Video Questionnaire in Vloggi',
        link: 'https://vloggi.com/docs/building-a-video-questionnaire-in-vloggi-enhancing-engagement-and-insight/',
      },
      {
        name: 'Do I need to incentivise my audience to contribute video submissions?',
        link: 'https://vloggi.com/docs/do-i-need-to-incentivise-my-audience-to-contribute-video-submissions/',
      },
    ]
  },
  {
    section: 'RE-USING VIDEO SUBMISSIONS',
    articles: [
      {
        name: 'Ways to manage your user-generated video library in Vloggi',
        link: 'https://vloggi.com/docs/ways-to-manage-your-user-generated-video-library-in-vloggi/',
      },
      {
        name: 'How to delete videos from your Vloggi user-generated video library',
        link: 'https://vloggi.com/docs/how-to-delete-videos-from-your-vloggi-user-generated-video-library/',
      },
      {
        name: 'How to download video submissions from my Vloggi library?',
        link: 'https://vloggi.com/docs/how-to-download-video-submissions-from-my-vloggi-library/',
      },
      {
        name: 'How do I make video compilations without editing software?',
        link: 'https://vloggi.com/docs/how-do-i-make-video-compilations-without-editing-software/',
      },
      {
        name: 'How to download video submissions in bulk as zipped folder on Vloggi',
        link: 'https://vloggi.com/docs/how-to-download-video-submissions-in-bulk-as-zipped-folder-on-vloggi/',
      },
      {
        name: 'Inviting Collaborators to Vote on a Video Contest',
        link: 'https://vloggi.com/docs/inviting-collaborators-to-vote-on-a-video-contest-a-collaborative-judging-process/',
      },
    ]
  }
]

const GetStarted = () => {
  return (
    <Section>
      <>
        <Title title="" />

        <SubSection>
          <>
            <Header as="h1" style={{ fontWeight: 'bold' }}>
              Help Center
              <Header.Subheader>
                Need help? The Co-Pilots (aka support team) are standing by.
              </Header.Subheader>
            </Header>
            
            <Divider style={{ margin: '2rem 0' }} />
            
            <Grid columns={3} stackable>
              {helpVideos.map((video) => (
                <Grid.Column key={video.videoLink}>
                  {video.provider === 'youtube' ? (
                    <>
                      <Header as="h4">Solving Video Consent</Header>
                      <div style={{ position: 'relative', paddingBottom: '66.01466992665037%', height: '0' }}>
                        <iframe
                          title="Solving Video Consent"
                          allowFullScreen
                          src="https://www.youtube.com/embed/k34i3_yssFg?ecver=1&iv_load_policy=1&rel=1&autohide=2&color=red&width=560&width=560"
                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%', border: 'none' }}
                        ></iframe>
                      </div>
                    </>
                  ) : (
                    <HelpCentreVideoThumbnail video={video}></HelpCentreVideoThumbnail>
                  )}
                </Grid.Column>
              ))}
            </Grid>
            
            <Divider style={{ margin: '2rem 0' }} />

            <Grid columns={2} stackable>
              <Grid.Column>
                <Button fluid primary size="large" as="a" href="https://vloggi.com/docs/vloggi-quick-start-guide/" target="_blank">
                  Vloggi Quick Start Guide
                </Button>
              </Grid.Column>
              <Grid.Column>
                <Button fluid primary size="large" as="a" href="https://vloggi.com/docs/how-to-collect-curate-and-combine-user-generated-videos-at-scale-with-vloggi-an-overview/" target="_blank">
                  How to use Vloggi: An overview
                </Button>
              </Grid.Column>
            </Grid>

            <Segment secondary style={{ marginTop: '2rem' }}>
              <Grid columns={2} stackable>
                {helpArticles.map((section) => (
                  <Grid.Column>
                    <h3><strong>{section.section}</strong></h3>
                    {section.articles.map((article) => (
                      <div style={{ display: 'flex', gap: '0.25rem', margin: '1rem 0' }}>
                        <Icon name="external alternate" />
                        <ExternalLink url={article.link}>{article.name}</ExternalLink>
                      </div>
                    ))}
                  </Grid.Column>
                ))}
              </Grid>
              <Divider></Divider>
              <ExternalLink url={HELPDOCS_URL}>Or check out or knowledge base</ExternalLink>
            </Segment>
          </>
        </SubSection>
      </>
    </Section>
  )
}

export default GetStarted
